module.exports = __webpack_public_path__ + "static/media/spoonerism-task (10).48cb5af6.mp3";